// Serviço para operações administrativas
import { supabase } from '../lib/supabase';

export interface EstatisticasAdmin {
  totalUsuarios: number;
  totalEmpresas: number;
  totalContas: number;
  totalAssinaturasAtivas: number;
  receitaMensal: number;
}

export interface UsuarioComEmpresas {
  usuarioId: string;
  email: string;
  nome: string;
  totalEmpresas: number;
  empresas: Array<{
    id: string;
    razaoSocial: string;
    nomeFantasia: string;
    cnpj: string;
    role: string;
  }>;
}

// Obter estatísticas do admin
export async function obterEstatisticasAdmin(): Promise<EstatisticasAdmin> {
  try {
    const { data, error } = await supabase.rpc('obter_estatisticas_admin');

    if (error) throw error;

    return {
      totalUsuarios: data?.total_usuarios || 0,
      totalEmpresas: data?.total_empresas || 0,
      totalContas: data?.total_contas || 0,
      totalAssinaturasAtivas: data?.total_assinaturas_ativas || 0,
      receitaMensal: Number(data?.receita_mensal || 0),
    };
  } catch (error) {
    console.error('[adminService] Erro ao obter estatísticas:', error);
    return {
      totalUsuarios: 0,
      totalEmpresas: 0,
      totalContas: 0,
      totalAssinaturasAtivas: 0,
      receitaMensal: 0,
    };
  }
}

// Obter usuários com suas empresas
export async function obterUsuariosComEmpresas(): Promise<UsuarioComEmpresas[]> {
  try {
    const { data, error } = await supabase.rpc('obter_usuarios_com_empresas');

    if (error) throw error;

    return (data || []).map((item: any) => ({
      usuarioId: item.usuario_id,
      email: item.email || '',
      nome: item.nome || item.email || 'Usuário sem nome',
      totalEmpresas: Number(item.total_empresas || 0),
      empresas: (item.empresas || []).map((emp: any) => ({
        id: emp.id,
        razaoSocial: emp.razao_social,
        nomeFantasia: emp.nome_fantasia,
        cnpj: emp.cnpj,
        role: emp.role,
      })),
    }));
  } catch (error) {
    console.error('[adminService] Erro ao obter usuários:', error);
    return [];
  }
}

// Criar empresa e vincular usuário
export async function criarEmpresaEVincularUsuario(
  empresaData: {
    razaoSocial: string;
    nomeFantasia: string;
    cnpj: string;
    inscricaoEstadual: string;
    email: string;
    telefone: string;
    cep: string;
    logradouro: string;
    numero: string;
    complemento?: string;
    bairro: string;
    cidade: string;
    estado: string;
  },
  usuarioId: string
): Promise<string> {
  try {
    const { data, error } = await supabase.rpc('criar_empresa_e_vincular_usuario', {
      p_razao_social: empresaData.razaoSocial,
      p_nome_fantasia: empresaData.nomeFantasia,
      p_cnpj: empresaData.cnpj,
      p_inscricao_estadual: empresaData.inscricaoEstadual,
      p_email: empresaData.email,
      p_telefone: empresaData.telefone,
      p_cep: empresaData.cep,
      p_logradouro: empresaData.logradouro,
      p_numero: empresaData.numero,
      p_complemento: empresaData.complemento || '',
      p_bairro: empresaData.bairro,
      p_cidade: empresaData.cidade,
      p_estado: empresaData.estado,
      p_usuario_id: usuarioId,
    });

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('[adminService] Erro ao criar empresa e vincular usuário:', error);
    throw error;
  }
}

